import React, {Fragment} from 'react'
import {Route} from '../components/Router'
import {Navigation} from '../components/Navigation'

import {default as Upload} from '../components/staticfiles/upload.js';
import {default as Publisher} from '../components/staticfiles/publisher.js';

export default function StaticfilesContainer(){
    return (
        <Fragment>
            <Route path="/staticfiles/publish/**" exact={true} component={Publisher} />
            <Route path="/staticfiles/files/**" exact={false} component={Upload} />
        </Fragment>
    )
}